module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "input title",
    attrs: {
      "type": "text",
      "placeholder": "Caption"
    },
    domProps: {
      "value": _vm.getCaption()
    },
    on: {
      "input": function($event) {
        return _vm.update('caption', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subTitle"
  }, [_c('b', [_vm._v("Song:")]), _vm._v("\n    " + _vm._s(_vm.playlistItem.song_version ? _vm.playlistItem.song_version.title : "?") + "\n  ")]), _vm._v(" "), _c('search-song', {
    attrs: {
      "show-tags": true,
      "initial-tags": _vm.songTags
    },
    on: {
      "selectSong": function($event) {
        return _vm.update('song_version', $event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77f80a71!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlaylistItemEdit.vue
// module id = 320
// module chunks = 2